// Modules
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// Components
import { LayoutContent, Spinner } from '@/ui';
import { StyledContainer, StyledContent, StyledRobotImage } from './AuthLayoutStyles';

const AuthLayout = () => {
  return (
    <StyledContainer>
      <StyledContent>
        <LayoutContent>
          <Suspense fallback={<Spinner />}>
            <Outlet />
          </Suspense>
        </LayoutContent>
      </StyledContent>
      <StyledRobotImage />
    </StyledContainer>
  );
};

export default AuthLayout;
